import { trendFetch } from 'api';
import { MediaItem } from 'types/content';
import { CreatorPortfolio, InfluencerPortfolio } from 'types/creator';
import { ProfileUpdates } from 'types/profile';
import { influencerPortfolioToCreatorPortfolio } from 'utils/creator';

export const patchCreatorProfile = (
  creatorId: string,
  profileUpdates: ProfileUpdates
) => {
  return trendFetch(`/creator/profile/${creatorId}`, {
    method: 'PATCH',
    body: JSON.stringify(profileUpdates),
  });
};

// TODO: Check status code
export const addPortfolioItem = async (
  item: MediaItem
): Promise<CreatorPortfolio> => {
  return trendFetch(`/creator/portfolio/add`, {
    method: 'POST',
    body: JSON.stringify({
      type: item.type,
      url: item.url,
    }),
  })
    .then((res) => res.json())
    .then((portfolio: InfluencerPortfolio) =>
      influencerPortfolioToCreatorPortfolio(portfolio)
    );
};

export const updatePortfolioItem = async (
  item: MediaItem
): Promise<CreatorPortfolio> => {
  await removePortfolioItem(item);
  return addPortfolioItem(item);
};

export const removePortfolioItem = async (
  item: MediaItem
): Promise<CreatorPortfolio> => {
  return trendFetch(`/creator/portfolio/remove`, {
    method: 'DELETE',
    body: JSON.stringify({ ...item }),
  })
    .then((res) => res.json())
    .then((portfolio: InfluencerPortfolio) =>
      influencerPortfolioToCreatorPortfolio(portfolio)
    );
};
